/* Merkt sich, welche Fotos und Logos in dieser Seitensitzung hochgeladen wurden.
 *
 * Wird nur gebraucht, um Zwischenstände aufzuräumen: Foto A hochgeladen, vor dem
 * Speichern durch Foto B ersetzt — A steht dann in keinem gespeicherten Stand und
 * wäre sonst nie auffindbar. Nur für Foto und Logo, bewusst nicht für alle
 * Uploads: Dokumente und Visa werden von fileCleanup.js nicht geprüft, ein
 * Eintrag dafür würde zu Unrecht als "nicht referenziert" gelten.
 *
 * Zustand im Modulbereich, nur im Speicher des Browsers (geht beim Neuladen
 * verloren — dann bleibt eine Datei liegen, mehr nicht).
 */

const uploaded = new Map(); // playerId -> [{ kind, path }]

export function trackUpload(playerId, kind, path) {
  if (!playerId || !path) return;
  const key = String(playerId);
  if (!uploaded.has(key)) uploaded.set(key, []);
  uploaded.get(key).push({ kind, path });
}

export function peekUploads(playerId) {
  return [...(uploaded.get(String(playerId)) || [])];
}

/** Nach erfolgreichem Speichern und Aufräumen: Liste dieses Spielers leeren. */
export function clearUploads(playerId) {
  uploaded.delete(String(playerId));
}
